import React from 'react';
import { differentiators } from '../data/content';
export function Differentiators() {
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-31" data-mp="1mcov2wbletnh">
      <div className="mx-auto max-w-2xl text-center" data-id="element-32" data-mp="1mb3xextzeule">
        <h2 className="text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-33" data-mp="1r3ncy0c8bzsu">
          This isn't just another neurology ebook
        </h2>
        <p className="mt-0.5 font-heading text-xs font-extrabold uppercase tracking-wide text-mid sm:text-sm" data-id="element-34" data-mp="1w4uhzrmzmkvt">
          It's a ready-to-use visual study system.
        </p>
        <div className="mt-2 grid gap-1.5 text-left sm:grid-cols-2" data-id="element-35" data-mp="13em9ysm61guy">
          {differentiators.map(item => <div key={item.title} className="rounded-md border border-navy/10 bg-mist px-2.5 py-2" data-id="element-36" data-mp="18fi8srrnucti">
              <h3 className="text-sm font-extrabold text-navy" data-id="element-37" data-mp="1da5qo7s5s8z4">
                <span aria-hidden="true" data-id="element-38" data-mp="2jrswijrjrir3">{item.icon}</span> {item.title}
              </h3>
              <p className="mt-0.5 text-sm leading-snug" data-id="element-39" data-mp="2oqmcqjy7xnuy">{item.body}</p>
            </div>)}
        </div>
        <p className="mt-2 font-heading text-xs font-extrabold uppercase tracking-wide text-mid sm:text-sm" data-id="element-40" data-mp="boamq8f1psm1">
          Less searching. Less confusion. More neurological clarity.
        </p>
      </div>
    </section>;
}